import React from 'react';
import RoomCard from './RoomCard';
import { Helmet } from 'react-helmet';

const rooms = [
  {
    image: 'img/rooms/room1.jpg',
    title: 'Om Sai PG Room',
    price: 'Sharing Room',
    amenities: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
  },
  {
    image: 'img/rooms/room2.jpg',
    title: 'Om Sai PG Room',
    price: 'Sharing Room',
    amenities: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
  },
  {
    image: 'img/rooms/room3.jpg',
    title: 'Om Sai PG Room',
    price: 'Sharing Room',
    amenities: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
  },
  {
    image: 'img/rooms/room4.jpg',
    title: 'Om Sai PG Room',
    price: 'Sharing Room',
    amenities: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
  },
  {
    image: 'img/rooms/room5.jpg',
    title: 'Om Sai PG Room',
    price: 'Sharing Room',
    amenities: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
  },
  {
    image: 'img/rooms/room6.jpg',
    title: 'Om Sai PG Room',
    price: 'Sharing Room',
    amenities: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
  },


  {
    image: 'img/pg-building (2).jpg',
    title: 'Om Sai PG Building',
    price: 'Sharing Room',
    amenities: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
  },
  {
    image: 'img/rooms/room10.jpg',
    title: 'Om Sai PG Room',
    price: 'Sharing Room',
    amenities: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
  },

  {
    image: 'img/pg-building.jpg',
    title: 'Om Sai PG Building',
    price: 'Sharing Room',
    amenities: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
  },
];

const Room = () => {
  return (
    <>
     

     <Helmet>
 
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Om Sai PG",
      "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
      "url": "https://www.omsaipg.in",
      "logo": "https://www.omsaipg.in/images/logo.jpg",
      "image":"https://www.omsaipg.in/images/ogimage.jpg",
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+91 9763888448",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
        {
          "@type": "ContactPoint",
          "telephone": "+91 9922248255",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "bestRating": "5",
        "worstRating": "1",
        "ratingValue": "4.7",
        "ratingCount": "250",
      },
      "email": "omsaipg@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
        "addressLocality": "Kharadi",
        "addressRegion": "Maharashtra",
        "postalCode": "411014",
        "addressCountry": "IN",
      },
      "sameAs": [
        "https://www.facebook.com/omsaipg",
        "https://www.instagram.com/omsaipg",
        "https://www.linkedin.com/company/omsaipg"
      ],
      "priceRange": "INR 8,500-6000",
      "paymentAccepted": "Cash, UPI, Credit Card",
      "telephone": "+91 9763888448",
      "email": "omsaipgpune@gmail.com",
      "keywords": [
        "PG in Pune",
        "PG in Kharadi",
        "PG with food in Pune",
        "PG for students in Kharadi",
        "PG for females in Pune",
        "PG for males in Pune",
        "Om Sai PG Kharadi",
        "Girls Hostels in Kharadi",
        "Boys Hostel in Kharadi",
        "Monthly Basis PG in Kharadi",
        "PG in Wagholi",
        "PG in Kharadi with food",
        "Hostels in Pune",
        "PG for Students in Kharadi Pune",
        "Paying Guest Hostel in Chandan Nagar"
      ],
      "openingHours": "Mo-Su 09:00-22:00"
    })}
  </script>

  {/* Title */}
  <title>
    Contact : +91 9763888448 / +91 9922248255 | Om Sai PG | Best Luxury PG in Pune | Best PG Near Eon IT Park Kharadi | Hostel in Kharadi |Om Sai PG Kharadi
  </title>

  {/* Meta Tags */}
  <meta
    name="description"
    content="Om Sai PG offers the best PG accommodations in Kharadi, Pune. We provide PG for students, males, females, with food and other essential amenities."
  />
  <meta
    name="keywords"
    content="Best Luxury PG in Pune, Best PG Near Eon IT Park Kharadi, Hostel in Kharadi,Om Sai PG Kharadi"
  />
  <meta name="robots" content="index, follow" />

  {/* Open Graph Tags */}
  <meta
    property="og:title"
    content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
  />
  <meta
    property="og:description"
    content="Looking for the best PG in Kharadi Pune? Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
  />
  <meta property="og:image" content="https://www.omsaipg.in/ogimage.jpg" />
  <meta property="og:url" content="https://www.omsaipg.in" />
  <meta property="og:type" content="website" />
</Helmet>


    <section className="section-room padding-tb-50">
      <div className="container">
        <div className="row mb-minus-24 room-popup container">
          <div className="col-12" data-aos="fade-up" data-aos-duration="1000">
            <div className="rx-banner text-center rx-banner-effects">
              <p>
                <img src="img/banner/left-shape.svg" alt="banner-left-shape" className="svg-img left-side" />
                Om Sai PG
                <img src="img/banner/right-shape.svg" alt="banner-right-shape" className="svg-img right-side" />
              </p>
              <h4>
                Our Best <span>Rooms</span>
              </h4>
            </div>
          </div>

          {rooms.map((room, index) => (
            <RoomCard
              key={index}
              image={room.image}
              title={room.title}
              price={room.price}
              amenities={room.amenities}
            />
          ))}
        </div>
      </div>
    </section>


</>
  );
};

export default Room;
